import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import styled from "styled-components";

const Recipe = () => {

    let params = useParams();
    const[detail, setDetail] = useState({});
    const[activeTab, setActive] = useState("instructions")

    const getDeteail = async() =>{
        const data = await fetch(`https://api.spoonacular.com/recipes/${params.name}/information?apiKey=${process.env.REACT_APP_API_KEY}`)
        const api = await data.json();
        setDetail(api)
    };

    useEffect(() =>{
        getDeteail();
    },[params.name])

  return (
    <Grid>
        <div>
            <h2>{detail.title}</h2>
            <img src={detail.image} alt="" />
        </div>
        <Info>
            <Button className={activeTab === "instructions" ? 'active' : ""} onClick ={() => setActive("instructions")}>
              Instructions
            </Button>
            <Button className={activeTab === "ingredients" ? 'active' : ""} onClick ={() => setActive("ingredients")}>
              Ingredients
            </Button>
            {activeTab === "instructions" && (
              <div className="detail">
                <p dangerouslySetInnerHTML={{__html: detail?.summary}}></p>
                <p dangerouslySetInnerHTML={{__html: detail?.instructions}}></p>
              </div>
              )}
               {activeTab === "ingredients" && (
                <ul>
                  {detail?.extendedIngredients.map((ingredient) =>{
                    return(
                      <li key={ingredient.id}>{ingredient.original}</li>
                    )
                  })}
                </ul>
              )}
        </Info>
    </Grid>
  )
};


const Button = styled.button`
  padding:0.5rem 1rem ;
  display: flex;
  justify-content: center;
  width: 136px;
  color: #313131;
  background: white;
  border: 2px solid black;
  margin-right: 2rem;
  font-weight: 600;
  margin-bottom: 30px;
  
`

const Info = styled.div`
  margin-left: 5rem ;
  display: flex;
  /* height: 100%; */
  flex-direction: column;
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  
  .active{
        background: linear-gradient(35deg, #494949, #313131);
        color: white;
    }
  img{
    border-radius: 2rem;
    margin-bottom: 30px;
  }
  h2{
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.8rem;
  }
  p{
    line-height: 30px;
    width: 100%;
  }
`


export default Recipe